import React from "react";
import { Link } from "react-scroll";
import { Parallax } from "react-parallax";
import { scrollDuration } from "../config/commonConfig";

const CallToAction = () => {
  return (
    <section>
      <div className="hero-wrap">
        <div className="hero-mask opacity-8 bg-dark" />
        <Parallax
          bgImage="images/perfil-github.png"
          bgImageAlt="Intro"
          strength={200}
        >
          <div className="hero-content section">
            <div className="container text-center py-5 wow fadeInUp">
              <h2 className="text-10 fw-600 text-white mb-5">
              My other projects
              </h2>
              
                <a
                      className=" btn-red-call rounded-0 smooth-scroll wow rubberBand"
                      data-wow-delay="1s"
                      smooth="easeInOutQuint"
                      duration={scrollDuration}
                      href="https://github.com/Rubi76X"
                      target="_blank"
                      rel="noopener noreferrer"

                    >
                      Visit! 
                    </a>{" "}
            </div>
          </div>
        </Parallax>
      </div>
    </section>
  );
};

export default CallToAction;
